import { useState } from "react";
import { Icon } from "./Icon";
import { Logo } from "./Logo";
import { useAuth } from "../auth/AuthContext";

const navigation = [
  { label: "Applications", href: "#applications" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
];

export function Header({ compact = false }: { compact?: boolean }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { profile, loading, signupEnabled, signOut } = useAuth();

  return (
    <header className="site-header">
      <div className="container header__inner">
        <div className="header__identity">
          <Logo />
          <span className="environment-badge"><span aria-hidden="true" />Demo Environment</span>
        </div>

        <button
          className="menu-button"
          type="button"
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <Icon name={menuOpen ? "x" : "menu"} />
        </button>

        <nav id="primary-navigation" className={`navigation ${menuOpen ? "navigation--open" : ""}`} aria-label="Primary navigation">
          {!compact && navigation.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setMenuOpen(false)}>{item.label}</a>
          ))}
          <span className="navigation__account">
            {loading ? <span className="account-loading" aria-label="Checking account" /> : profile ? <>
              {profile.administrator && <a className="navigation__admin" href="https://admin.prt-technology.com">Admin</a>}
              <a className="profile-link" href="/profile" aria-label={`Open profile for ${profile.name}`}><span aria-hidden="true">{profile.name.trim().charAt(0).toUpperCase()}</span><strong>Profile</strong></a>
              <button className="header-signout" type="button" onClick={() => void signOut()}>Log out</button>
            </> : <>
              <a className="login-link" href="/login">Log in</a>
              {signupEnabled && <a className="signup-link" href="/signup">Request access</a>}
            </>}
          </span>
        </nav>
      </div>
    </header>
  );
}
